import { uniqueId } from 'lodash';
import PropTypes from 'prop-types';
import { InfoLabel, ProgressBar } from '../../../common/components';
import DashboardTooltip from '../utils/DashboardTooltip';
import {
  currencyFormatter,
  currencyFormatterInShort,
  DASHBOARD_COLORS,
} from '../utils/dashboardConstants';
import NoData from '../utils/no-data';
import DashboardCardLayout from './layout';

function ReceivablesAmountProgress({ data }) {
  return (
    <div className="receivables-amount-progress">
      <div>
        <InfoLabel label={data.title} />
        <div>
          <DashboardTooltip
            id={uniqueId('receivables-amount-progress')}
            position="bottom"
            value={data.amount}
            label={currencyFormatterInShort(data.amount)}
            tooltipText={currencyFormatter(data.amount)}
          />
        </div>
      </div>
      <ProgressBar
        className="table-card-graph"
        value={data.percent}
        color={data.color}
        width={150}
      />
    </div>
  );
}
ReceivablesAmountProgress.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired,
    color: PropTypes.string.isRequired,
  }).isRequired,
};

function Receivables({ data }) {
  return (
    <>
      <ReceivablesAmountProgress
        data={{
          title: 'Current Due',
          amount: data.outstandingAmount,
          percent: data.outstandingAmountPercent,
          color: DASHBOARD_COLORS.RECEIVABLES.OUTSTANDING,
        }}
      />
      <ReceivablesAmountProgress
        data={{
          title: 'Past Due',
          amount: data.overDueAmount,
          percent: data.overDueAmountPercent,
          color: DASHBOARD_COLORS.RECEIVABLES.OVERDUE,
        }}
      />
    </>
  );
}

Receivables.propTypes = {
  data: PropTypes.shape({
    outstandingAmount: PropTypes.number.isRequired,
    outstandingAmountPercent: PropTypes.number.isRequired,
    overDueAmount: PropTypes.number.isRequired,
    overDueAmountPercent: PropTypes.number.isRequired,
  }).isRequired,
};

function ReceivablesCard({ data, bgColor }) {
  return (
    <DashboardCardLayout
      title="Receivables"
      cardTitle="Total Receivables"
      tooltip="The amounts owed to Cypress Lawn by customers or contracts entered on credit."
      options={{ bgColor }}
      data={data}
      className="bottom-tooltip"
    >
      {typeof data.amount === 'number' ? <Receivables data={data} /> : <NoData />}
    </DashboardCardLayout>
  );
}

ReceivablesCard.propTypes = {
  bgColor: PropTypes.string.isRequired,
  data: PropTypes.shape({
    amount: PropTypes.number.isRequired,
  }).isRequired,
};

export default ReceivablesCard;
